// frontend/src/app/project-corpus/ports/project-corpus.port.ts
import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CreateImportJobRequest,
  FailedUpload,
  GroupCorpusPaper,
  ImportJob,
  ImportSizeEstimate,
  Page,
  PageRequest,
  PaperListFilter,
  PaperMetadataPatch,
  ProjectPaper,
  ProjectSummary,
} from '../domain/types';

export interface ProjectCorpusPort {
  // Reads
  getProjectSummary(projectId: string): Observable<ProjectSummary>;
  listImportJobs(projectId: string, page: PageRequest): Observable<Page<ImportJob>>;
  listPapers(
    projectId: string,
    filter: PaperListFilter,
    page: PageRequest,
  ): Observable<Page<ProjectPaper>>;
  searchGroupCorpus(
    groupId: string,
    q: string,
    projectId: string,
    page: PageRequest,
  ): Observable<Page<GroupCorpusPaper>>;

  // OpenAlex preview (read-ish, returns ephemeral data)
  previewOpenAlex(
    query: string,
    workTypes: string[],
    sourceTypes: string[],
    yearFrom?: number,
    yearTo?: number,
    language?: string[],
  ): Observable<ImportSizeEstimate>;

  // Writes
  createImportJob(projectId: string, request: CreateImportJobRequest): Observable<ImportJob>;
  advanceToScreening(projectId: string, force?: boolean): Observable<void>;
  editPaperMetadata(paperId: string, patch: PaperMetadataPatch): Observable<ProjectPaper>;
  attachPdf(paperId: string, file: File): Observable<ProjectPaper>;

  // Extraction retry + failed-upload management
  retryExtraction(pdfId: string, projectId: string): Observable<void>;
  listFailedUploads(jobId: string): Observable<FailedUpload[]>;
  deleteFailedUpload(jobId: string, failureId: string): Observable<void>;
  updateImportJobTitle(jobId: string, title: string): Observable<ImportJob>;

  /** Reverts a completed import job during SETUP/INGESTION. */
  undoImportJob(jobId: string): Observable<void>;
}

export const PROJECT_CORPUS_PORT = new InjectionToken<ProjectCorpusPort>('PROJECT_CORPUS_PORT');
